export function hasRecommendationHealthRule(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  member: any,
  atribute: string,
  base: string
) {
  if (base === 'agents') {
    if (atribute === 'vaccinesCard' || atribute === 'vaccinesUpToDate') {
      if (
        member.health[atribute].answer === undefined ||
        String(member.health[atribute].answer).startsWith('Não')
      ) {
        return true
      }
    }
    if (atribute === 'disability') {
      if (
        member.health[atribute].answer !== 'Não possui nenhuma deficiência' &&
        String(member.health.familyHealthTeam.answer).startsWith('Não')
      ) {
        return true
      }
    }
  } else {
    if (atribute === 'disability') {
      if (
        member.health[atribute].answer !== 'Não possui nenhuma deficiência' &&
        String(member.health.thirdPartyAssistance.answer).startsWith('Não')
      ) {
        return true
      }
    }
  }
  return false
}
